import Vue from 'vue'
import VueRouter from 'vue-router'
import { concat } from 'lodash'
import guest from './guest'
import common from './common'
import account from './account'
import apps from './apps'
import environments from './environments'
import audits from './audits'
import teams from './teams'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes: concat(
    common,
    guest,
    account,
    apps,
    environments,
    audits,
    teams,
  )
})

export default router
